export default __webpack_public_path__ + "static/media/uploader-oneTouchUltra2-4.ec6d9447.png";